import { getType } from 'typesafe-actions';

import { NetworkRequestState } from '@bolteu/redux-session';

import {
  PromotionAccessType,
  PromotionsPermissions,
} from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryCampaignProvider/apis';
import { PromotionsPermissionsAction, requestPromotionsPermissionAsyncAction } from './actions';

type InitialPromotionsPermissions = Omit<PromotionsPermissions, 'promotion_access_type'> & {
  promotion_access_type: PromotionAccessType | null;
};

export interface PromotionsPermissionsState {
  result: InitialPromotionsPermissions | null;
  fetchingState: NetworkRequestState;
  error?: Error;
  updateRequestState: NetworkRequestState;
}

const initialState: PromotionsPermissionsState = {
  result: {
    can_view_selected_items_menu_editor: false,
    promotion_access_type: null,
    paid_visibility_offer_id: null,
    has_paid_visibility_offer: false,
    has_multiple_paid_visibility_offers: false,
    smart_promotions_enabled: false,
    net_revenue_uplift: 0,
    should_skip_landing_page: false,
    currency_symbol: '',
    is_sponsored_listing_bundle_discount_enabled: false,
  },
  fetchingState: NetworkRequestState.unset,
  updateRequestState: NetworkRequestState.unset,
};

export const promotionsPermissionReducer = (
  state: PromotionsPermissionsState = initialState,
  action: PromotionsPermissionsAction,
): PromotionsPermissionsState => {
  switch (action.type) {
    case getType(requestPromotionsPermissionAsyncAction.request): {
      return {
        ...state,
        result: null,
        fetchingState: NetworkRequestState.waiting,
      };
    }
    case getType(requestPromotionsPermissionAsyncAction.success): {
      return {
        ...state,
        result: action.payload.result,
        fetchingState: NetworkRequestState.success,
      };
    }
    case getType(requestPromotionsPermissionAsyncAction.failure): {
      return {
        ...state,
        fetchingState: NetworkRequestState.failure,
      };
    }

    default: {
      return state;
    }
  }
};
